import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import Select from 'react-select';
import {customStyles, FilterContainer, SelectContainer} from "./index";

const FilterLabel = styled.label`
    margin-right: 10px;
    font-size: 16px;

    @media (max-width: 768px) {
        margin-bottom: 5px;
    }
`;

const FilterDropdown = styled(Select)`
  width: 100px;
  margin-right: 10px;
`;

const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const InputContainer = styled.div`
    display: flex;
    align-items: center;
    margin-right: 15px;

    @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 10px;
    }
`;

export class RecentMissed extends Component {
  state = {
    missedDoses: {value: '5', label: '5'},
    siteFilter: { value: 'all', label: 'All Sites' },
    medFilter: { value: 'all', label: 'All Meds' },
  };

  columns = [
    {
      name: 'Patient',
      selector: row => row.patient,
      sortable: true,
    },
    {
      name: 'Medication',
      selector: row => row.medication,
      sortable: true,
    },
    {
      name: 'Date Activated',
      selector: row => row.dateActivated,
      sortable: true,
    },
    {
      name: 'Schedule',
      selector: row => row.schedule,
      sortable: true,
    },
    {
      name: 'Contact',
      selector: row => row.contact,
      sortable: true,
    },
    {
      name: 'Last Dose Taken',
      selector: row => row.lastDoseTaken,
      sortable: true,
    },
    {
      name: 'Last 5 Doses',
      selector: row => row.last5Doses,
      cell: row => (
        <div style={{ display: 'flex', justifyContent: 'space-around', minWidth: '100px' }}>
          {row.last5Doses.map((dose, index) => (
            <span key={index} className={`fas ${dose ? 'fa-check' : 'fa-times'}`}
                  style={{ color: dose ? 'green' : 'red' }}>
            </span>
          ))}
        </div>
      ),
    },
  ];

  data = [
    // Sample data - replace with your actual data
    {
      patient: 'John Doe',
      medication: 'Medication A',
      dateActivated: '2023-01-01',
      schedule: 'Daily',
      contact: '123-456-7890',
      lastDoseTaken: '2023-05-10',
      last5Doses: [true, false, true, false, true],
    },
    {
      patient: 'Jane Smith',
      medication: 'Medication B',
      dateActivated: '2023-02-15',
      schedule: 'Weekly',
      contact: '987-654-3210',
      lastDoseTaken: '2023-05-09',
      last5Doses: [true, true, false, false, true],
    },
  ];

  handleMissedDosesChange = (event) => {
    this.setState({ missedDoses: event.target.value });
  };

  handleSelectChange = (selectedOption, action) => {
    this.setState({ [action.name]: selectedOption });
  };

  render() {
    const { missedDoses, siteFilter, medFilter } = this.state;

    const siteOptions = [
      { value: 'all', label: 'All Sites' },
      { value: 'site1', label: 'Site 1' },
      { value: 'site2', label: 'Site 2' },
    ];

    const medOptions = [
      { value: 'all', label: 'All Meds' },
      { value: 'med1', label: 'Med 1' },
      { value: 'med2', label: 'Med 2' },
    ];

    const missedDoseOptions = [
      {value: 'atLeast1', label: 'At least 1'},
      {value: '2More', label: '2 or more'},
      {value: '3More', label: '3 or more'},
      {value: '4More', label: '4 or more'},
      {value: '5', label: '5'},
    ];

    return (
      <div>
        <FilterContainer>
          <InputContainer>
            <FilterLabel>Patients that have missed</FilterLabel>
            <SelectContainer>
              <Select
                name="missedDoses"
                value={missedDoses}
                onChange={this.handleSelectChange}
                options={missedDoseOptions}
                placeholder=""
              />
            </SelectContainer>
            <FilterLabel>of the last 5 doses.</FilterLabel>
          </InputContainer>
          <SelectContainer>
            <Select
              name="siteFilter"
              value={siteFilter}
              onChange={this.handleSelectChange}
              options={siteOptions}
              placeholder="All Sites"
            />
          </SelectContainer>
          <SelectContainer>
            <Select
              name="medFilter"
              value={medFilter}
              onChange={this.handleSelectChange}
              options={medOptions}
              placeholder="All Meds"
            />
          </SelectContainer>
        </FilterContainer>

        <DataTable
          columns={this.columns}
          data={this.data}
          customStyles={customStyles}
          pagination
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AdherenceDashboard/RecentMissed.jsx